export const SET_CUSTOMER = "setCustomer";
export const SET_CUSTOMERS = "setCustomers";
export const DELETE_CUSTOMER = "deleteCustomer";
